/* TeamsAppForYouSkeleton.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2iEGP258Nz%7Bgrid-template-columns%3Arepeat(auto-fill%2Cminmax(168px%2C1fr))%7D");
import React from 'react';
import { Grid } from '@atlaskit/primitives/compiled/grid';
import { Stack } from '@atlaskit/primitives/compiled/stack';
import { PersonCardSkeleton } from '@atlassian/people-teams-ui/person-card-skeleton';
import { ResponsiveLoadingState } from '@townsquare/loading-state/responsive';
import { AgentsRowSkeleton } from './AgentsRow';
import { KudosRowSkeleton } from './KudosRow/KudosSkeleton';
import { TeamsRowSkeleton } from './TeamsRow/TeamsRowGrid';
const styles = {
  peopleRowGrid: "_2iEGP258Nz"
};
const PeopleRowLoadingSkeleton = () => {
  return <ResponsiveLoadingState>
			<Grid gap="space.250" xcss={styles.peopleRowGrid}>
				{[0, 1, 2, 3, 4, 5].map(i => <PersonCardSkeleton key={`loading-state-${i}`} />)}
			</Grid>
		</ResponsiveLoadingState>;
};
export const TeamsAppForYouSkeleton = ({
  showKudos
}: {
  showKudos?: boolean;
}): React.JSX.Element => {
  return <Stack space="space.600">
			<PeopleRowLoadingSkeleton />
			<TeamsRowSkeleton />
			<AgentsRowSkeleton />
			{showKudos ? <KudosRowSkeleton /> : null}
		</Stack>;
};